import { RouteObject, useLocation, useRoutes } from 'react-router-dom';
import React, { useEffect } from 'react';
import Login from '@/pages/login/Login';
import { useRouter, useUserInfo } from '@/hooks/hooks';
import useAuth from '@/hooks/useAuth';
import Root from '@/common/Root';
import { useDispatch } from '@/hooks/hooks';
import { resetState } from '@/store/slices/page';
import manaRouter from '@/pages/mana/router';
import frontRouter from '@/pages/front/router';
import NoPermission from '@/pages/common/NoPermission';
import ResetPassword from '@/pages/login/ResetPassword';

export interface RouterMeta {
  name?: string;
  icon?: string;
  isRedirect?: boolean;
}
export interface RouterWithMeta extends RouteObject {
  meta?: RouterMeta,
  children?: RouterWithMeta[];
}
const router: RouteObject[] = [
  ...manaRouter,
  ...frontRouter,
  {
    path: '/',
    element: <Root />
  },
  {
    path: '/login',
    element: <Login></Login>
  },
  {
    path: '/nopermission',
    element: <NoPermission></NoPermission>
  },
  // 修改密码
  {
    path: '/resetPassword',
    element: <ResetPassword></ResetPassword>
  }
];

// 路由白名单
const whiteList = [
  '/login',
  '/resetPassword',
  '/nopermission'
];

const Router = () => {
  const navigator = useRouter();
  const location = useLocation();
  const { isLogin } = useAuth();
  const dispatch = useDispatch();
  const userState = useUserInfo();
  dispatch(resetState());
  useEffect(() => {
    if (!isLogin && !whiteList.includes(location.pathname)) {
      navigator.to('/login');
    }
    if (userState.userType === 'ADMIN' && location.pathname.includes('front')) {
      navigator.to('/nopermission');
    }
    if (userState.userType !== 'ADMIN' && location.pathname.includes('mana')) {
      navigator.to('/nopermission');
    }
  }, [location]);

  return useRoutes(router);
};

export default Router;